import React from 'react';
import styles from "./CardItem.module.css";
import { Link } from "react-router-dom";
import { FaBox, FaPlus, FaFire } from "react-icons/fa";

function CardItem({ id_item, src, label_title, p_descricao, p_preco, adicionarAoCarrinho, id_estabelecimento, maisPedido, quantidade, hideAddBtn }) {

  const addCart = (e) => {
    e.preventDefault();
    e.stopPropagation();

    // Extrair o número do preço (remover "R$" e converter para número)
    const precoNumerico = typeof p_preco === 'string'
      ? parseFloat(p_preco.replace('R$', '').replace(',', '.').trim())
      : parseFloat(p_preco);

    const item = {
      id_item,
      id_estabelecimento,
      src,
      label_title,
      preco: precoNumerico,
      quantidade: 1
    };
    adicionarAoCarrinho(item);
    console.log("Item adicionado ao carrinho", item);
  }

  // Função para truncar a descrição
  const truncateDescription = (text, maxLength = 50) => {
    if (!text) return "";
    if (text.length <= maxLength) return text;
    return text.substring(0, maxLength) + "...";
  }

  return (
    <Link to={`/pedidoclique/${id_item}`} state={{ id_item, id_estabelecimento, src, label_title, p_preco, p_descricao }} className={styles.cardLink}>
      <div className={styles.card_item}>
        <div className={styles.imageContainer}>
          <img src={src} alt={label_title} className={styles.card_image} />
          {maisPedido && (
            <span className={styles.badge}><FaFire className={styles.fireIcon} /> Mais pedido</span>
          )}
        </div>

        <div className={styles.card_content}>
          <h3 className={styles.item_title}>{label_title}</h3>
          {p_descricao && (
            <p className={styles.item_descricao}>
              {truncateDescription(p_descricao)}
            </p>
          )}
          <div className={styles.infoFooter}>
            {quantidade !== undefined && (
              <div className={styles.estoque}>
                <span className={styles.estoqueDot} />
                <span>{quantidade} {quantidade === 1 ? 'disponível' : 'disponíveis'}</span>
              </div>
            )}
            <p className={styles.p_preco}>{p_preco}</p>
          </div>
        </div>

        {!hideAddBtn && (
          <button className={styles.addBtnCard} onClick={addCart} title="Adicionar ao carrinho">
            <FaPlus className={styles.iconAdd} />
          </button>
        )}
      </div>
    </Link>
  );
}

export default CardItem;
